import React from "react";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";
import _ from "lodash";
import classNames from "classnames";

import "./KompressorImage.css";

/* Hinweis um Wartungen testen zu können:
 * for i in 0; do echo -en '\x00\x01' | dd of=/tmp/eeprom bs=2 count=1 seek=$((160 + $i)); done
 * ACHTUNG: byte-ordering ist hier "verdreht", obige Zeile setzt den Wert 0x100, also 256.
 * Anstatt 0 (Wasserfilter) können auch andere Werte stehen:
 * 0 -> Wasserfilter
 * 1 -> Ansaugfilter
 * 2 -> Ölfilter
 * 3 -> Ölabscheider
 * 4 -> Motor
 * 5 -> Kompressor (immer gelber Rahmen?)
 * 6 -> (Reserve)
 * 7 -> Universal1
 * 8 -> Universal2
 * 9 -> Universal3
 * 10 -> Universal4
 * 11 -> Jahreswartung
 * Um das Intervall zu ändern:
 * for i in 0; do echo -en '\x00\x01' | dd of=/tmp/eeprom bs=2 count=1 seek=$((176 + $i)); done
 */

const image_standard = "/schemakstandard438x340.png";
const image_lento = "/schemaklento438x340.png";
const image_belt = "/schemakbelt438x340.png";

const pkt_images = [
	null,
	"/pktwartung20x20.png",
	"/pktwarnung20x20.png",
	"/pktstoerung20x20.png"
];

const compressorImageName = compressor => {
	return [
		undefined,		/* 0: unknown */
		image_standard,	/* 1: variable */
		image_standard,	/* 2: gear */
		image_standard,	/* 3: direct */
		image_belt,		/* 4: belt */
		image_standard,	/* 5: flex */
		image_lento,	/* 6: lento */
		image_standard,	/* 7: combi */
		image_standard,	/* 8: combi-t */
		image_standard,	/* 9: simplexx */
		image_standard,	/* 10: duplexx */
		image_standard,	/* 11: dynamic */
		image_standard,	/* 12: v-drive */
		image_standard,	/* 13: g-drive */
		image_standard,	/* 14: v-drive-t*/
		image_standard	/* 15: g-drive-t */
	][compressor.almig_type];
};

const showMaintenanceFrame = {};

const indicator_actions = [{
	image: null,
	actions: null
}, {
	image: image_standard,
	actions: [
		[ 120, 150 ],	// 0
		[ 142, 173 ],	// 1
		[ 210,  90 ],	// 2
		[ 185, 180 ],	// 3
		[ 250, 215 ],	// 4
		[ 300, 170 ],	// 5
		[ 210, 275 ],	// 6
		[ 345,  95 ],	// 7
		[ 375, 185 ],	// 8
		[ 360, 245 ],	// 9
		[ 290, 140 ],	// 10
		[ 310, 200 ],	// 11
		[ 325, 240 ],	// 12
		null,			// 13
		showMaintenanceFrame,	// 14, Wartungsrahmen
		null			// 15 
	]
}, {
	image: image_belt,
	actions: [
		[ 110, 160 ],	// 0
		[ 140, 190 ],	// 1
		[ 190, 110 ],	// 2
		[ 205, 200 ],	// 3
		[ 255, 195 ],	// 4
		[ 290, 165 ],	// 5
		[ 210, 270 ],	// 6
		[ 340,  90 ],	// 7
		[ 365, 167 ],	// 8
		[ 360, 227 ],	// 9
		[ 288, 135 ],	// 10
		[ 310, 194 ],	// 11
		[ 290, 240 ],	// 12
		null,			// 13
		showMaintenanceFrame,	// 14, Wartungsrahmen
		null			// 15 
	]
}, {
	image: image_lento,
	actions: [
		[ 102,  50 ],	// 0
		[ 180,  55 ],	// 1
		[ 105,  85 ],	// 2
		[ 280,  85 ],	// 3
		[  85, 130 ],	// 4
		[ 155, 135 ],	// 5
		[ 200, 140 ],	// 6
		[ 280, 175 ],	// 7
		[ 355, 190 ],	// 8
		[ 140, 210 ],	// 9
		[ 255, 235 ],	// 10
		null,			// 11
		null,			// 12
		null,			// 13
		showMaintenanceFrame,	// 14, Wartungsrahmen
		null			// 15 
	]
}];

class KompressorImage extends React.Component {

	static propTypes = {
		compressor: PropTypes.object.isRequired,
		errors: PropTypes.arrayOf(PropTypes.object).isRequired
	};

	render() {
		const { compressor, errors } = this.props;
		const image_name = compressorImageName(compressor);
		if (!image_name) {
			return <div className="almig-unknown-compressor-image" />;
		}
		let indicators = [];
		let show_maintenance_frame = false;
		for (let comp of errors) {
			if (comp.cindex !== compressor.cindex) {
				continue;
			}
			for (let ind of indicator_actions) {
				if (ind.image !== image_name) {
					continue;
				}
				for (let prop in comp.indicators) {
					const indicator_value = comp.indicators[prop];
					if (!indicator_value) {
						continue;
					}
					const index = parseInt(prop, 10);
					const action = ind.actions[index];
					if (!action) {
						continue;
					}
					if (_.isArray(action)) {
						indicators.push(
							<Image key={indicators.length} className="almig-indikator"
								src={pkt_images[indicator_value]}
								style={{ left: action[0], top: action[1] }} />);
					}
					else {
						show_maintenance_frame = true;
					}
				}
			}
		}
		return (
			<div className="almig-kompressor-bild">
				<Image src={image_name} className={classNames({
					"almig-kompressor-mit-wartung": show_maintenance_frame
				})} />
				{indicators}
			</div>
		);
	}
}

export default KompressorImage;
